import { render, staticRenderFns } from "./ship-quote-results.vue?vue&type=template&id=459a978f&scoped=true"
import script from "./ship-quote-results.vue?vue&type=script&setup=true&lang=js"
export * from "./ship-quote-results.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459a978f",
  null
  
)

export default component.exports